import React from 'react'

const ArrowRight = () => {
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M7.8764 0.184011C7.6564 0.239344 7.51107 0.432011 7.51107 0.666678C7.51107 0.891344 7.57173 0.968678 8.02173 1.31134C8.8284 1.92534 9.61507 2.60068 10.1437 3.13334L10.4871 3.48001L5.50373 3.49334C0.161734 3.50734 0.475734 3.49868 0.323734 3.63668C0.223734 3.72734 0.177734 3.84201 0.177734 4.00001C0.177734 4.15801 0.223734 4.27268 0.323734 4.36334C0.475734 4.50134 0.161734 4.49268 5.50373 4.50668L10.4871 4.52001L10.1437 4.86668C9.61507 5.39934 8.8284 6.07468 8.02173 6.68868C7.57173 7.03134 7.51107 7.10868 7.51107 7.33334C7.51107 7.62134 7.71173 7.82201 7.99973 7.82201C8.1844 7.82201 8.21173 7.80668 8.72773 7.40668C9.88107 6.51268 10.8704 5.61801 11.3164 5.06468C11.6637 4.63401 11.8211 4.30134 11.8211 4.00001C11.8211 3.39734 11.1537 2.59068 9.53307 1.23601C9.15507 0.920678 8.3944 0.327344 8.26307 0.246011C8.15573 0.180011 7.99573 0.154011 7.8764 0.184011Z" 
        fill="currentColor"
      />
    </svg>
  )
}

export default ArrowRight